import React, { useEffect, useRef } from 'react';

const GoogleSignInButton = ({ onSuccess }) => {
  const buttonRef = useRef(null); // To track initialization status

  useEffect(() => {
    /* global google */
    if (window.google && !buttonRef.current) {
      // Initialize Google API
      window.google.accounts.id.initialize({
        client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
        callback: (response) => {
          // response.credential is the Google ID token
          onSuccess(response.credential);
        }
      });

      // Render the Google Sign-In button only once
      window.google.accounts.id.renderButton(
        document.getElementById('googleSignInDiv'),
        { theme: 'outline', size: 'large' }
      );

      buttonRef.current = true; // Mark as initialized
    }
  }, [onSuccess]);

  return <div id="googleSignInDiv"></div>;
};

export default GoogleSignInButton;
